<template>
  <div class="product-category-page">
    <!-- 顶部操作栏 -->
    <div class="top-header">
      <h2>产品分类</h2>
      <template v-if="isDesktop">
        <el-button type="primary" @click="handleAdd">添加分类</el-button>
      </template>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <!-- 产品分类列表 -->
      <el-table :data="newsCategoryList" style="width: 100%">
        <el-table-column prop="id" label="序列" width="80" />
        <el-table-column v-for="item in languageList" :key="item.code" :prop="`name_${item.code}`" :label="`${item.name} (${item.code})`">
          <template slot-scope="scope">
            {{ scope.row.translations[`${item.code}`] ? scope.row.translations[`${item.code}`].name : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 添加/编辑对话框 -->
    <template v-if="isDesktop">
      <el-drawer
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        size="70%"
        :before-close="handleClose"
      >
        <add-news-category
          :newsCategory="editingItem"
          @save="handleSave"
          @cancel="handleClosePopup"
        />
      </el-drawer>
    </template>
    <template v-else>
      <van-popup
        v-model="dialogVisible"
        position="bottom"
        :round="true"
        :style="{ height: '80%' }"
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <h3>{{ dialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <add-news-category
            :newsCategory="editingItem"
            @save="handleSave"
            @cancel="handleClosePopup"
          />
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import AddNewsCategory from './components/add-news-category.vue'
import { getLanguage } from '@/api/public'
import { getNewsCategories, deleteNewsCategory } from "@/api/website"
import { Dialog } from 'vant'

export default {
  name: 'NewsCategoryPage',
  components: {
    AddNewsCategory
  },
  data() {
    return {
      isDesktop: true,
      languageList: [],
      dialogVisible: false,
      dialogTitle: '',
      editingItem: null,
      newsCategoryList: []
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
    this.getNewsCategoryList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    getNewsCategoryList() {
      getNewsCategories().then(res => {
        this.newsCategoryList = res.data || []
      })
    },
    handleAdd() {
      this.dialogTitle = '添加动态分类'
      this.editingItem = null
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.dialogTitle = '编辑产品分类'
      this.editingItem = { ...item }
      this.dialogVisible = true
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNewsCategory(id).then(res => {
          if(res.code === 200) {
            this.getNewsCategoryList()
            this.$message.success('删除成功')
          }
        })
      }).catch(() => {})
    },
    handleSave(data) {
      // 保存成功后刷新列表
      this.getNewsCategoryList()
      this.$message.success('保存成功')
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.dialogVisible = false
      }).catch(function() {})
    }
  }
}
</script>

<style scoped lang="scss">
.product-category-page {
  width: 100%;
  padding: 20px;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.top-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content-container {
  min-height: 400px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  background-color: #f5f7fa;
  border-radius: 8px;
  margin-top: 20px;
}

/* 移动端弹出框样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.popup-content {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-category-page {
    padding: 10px;
  }
  
  .top-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>